// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/packet/packet.less
// module id = 593
// module chunks = 0